// # Bank Management Component for Admin
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../../../auth/state';
import SharedHeader from '../../../../../components/SharedHeader';
import DashboardFooter from '../../../../../components/DashboardFooter';
import budgetImage from '../../../../../aneo_media/finance/budget.png';
import './bank.css';

const Bank = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAuthStore();

  // # Team members data with local images
  const teamMembers = [
    {
      id: 'ahmed_hadidy',
      name: 'Ahmed Elhadidy',
      role: 'CEO - Head of Research & Development Department',
      image: '/icons/team/Elhadidy.png',
      bankInfo: 'Protected Information'
    },
    {
      id: 'nabil_mostafa',
      name: 'Nabil Mostafa',
      role: 'Head of Finance Department',
      image: '/icons/team/Nabil.png',
      bankInfo: 'Protected Information'
    },
    {
      id: 'ahmed_ayman',
      name: 'Ahmed Ayman',
      role: 'Head of Mentorship Department',
      image: '/icons/team/Ayman.jpeg',
      bankInfo: 'Protected Information'
    },
    {
      id: 'ahmed_hussein',
      name: 'Ahmed Hussein',
      role: 'Head of Marketing & public Relations Department',
      image: '/icons/team/Hussein.png',
      bankInfo: 'Protected Information'
    },
    {
      id: 'hossam_gomaa',
      name: 'Hossam Gomaa',
      role: 'Head of Content Management Department',
      image: '/icons/team/Hossam.png',
      bankInfo: 'Protected Information'
    },
    {
      id: 'project-budget',
      name: 'Project Budget',
      role: 'Project Financial Planning Account',
      image: budgetImage,
      bankInfo: 'Protected Information'
    }
  ];

  // # Redirect if not admin
  React.useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);

  // # Handle member click to view bank account
  const handleMemberClick = (memberId) => {
    if (memberId === 'project-budget') {
      navigate(`/admin/financial/banco/budget`);
    } else {
      navigate(`/admin/financial/banco/account/${memberId}`);
    }
  };

  return (
    <div className="bank_sys_page">
      <SharedHeader />
      
      <main className="bank_sys_content">
        <div className="bank_sys_header">
          <h1>Bank Management System</h1>
          <div className="bank_sys_header-buttons">
            <button 
              className="bank_sys_tutors-button"
              onClick={() => navigate('/admin/financial/banco/tutors')}
            >
              View Tutor Accounts
            </button>
            <button 
              className="bank_sys_back-button"
              onClick={() => navigate('/admin/financial')}
            >
              Back to Financial System
            </button>
          </div>
        </div>

        <div className="bank_sys_members-grid">
          {teamMembers.map((member) => (
            <div 
              key={member.id} 
              className="bank_sys_member-card"
              onClick={() => handleMemberClick(member.id)}
            >
              <div className="bank_sys_member-image">
                <img src={member.image} alt={member.name} />
              </div>
              <div className="bank_sys_member-info">
                <h3>{member.name}</h3>
                <p className="bank_sys_member-role">{member.role}</p>
                <div className="bank_sys_bank-info">
                  <p>{member.bankInfo}</p>
                  <button 
                    className="bank_sys_view-details"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMemberClick(member.id);
                    }}
                  >
                    View Bank Account
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter />
    </div>
  );
};

export default Bank;
